import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  invoices: [],
  // Set on first successful fetch — invoices are no longer preloaded at app startup (see
  // App.js); pages fetch on demand via useEnsureInvoices, once per session.
  invoicesLoaded: false,
  orders: []
};

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    // General loading and error handling actions
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Invoices
    getInvoicesSuccess: (state, action) => {
      state.invoices = action.payload;
      state.invoicesLoaded = true;
      state.isLoading = false;
    },

    // Orders
    getOrdersSuccess: (state, action) => {
      state.orders = action.payload;
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  getInvoicesSuccess,
  getOrdersSuccess
} = billingSlice.actions;

export default billingSlice.reducer;
